import { Component } from "@angular/core";

@Component({
  selector: "close-svg",
  templateUrl: "./close.component.svg",
  styleUrls: ["./close.component.scss"],
})
export class CloseSvgComponent { }
